<div class="restricted-access">
  <h2>Accès restreint</h2>
  <p>Vous n'êtes pas autorisé à accéder à l'application.</p>
</div>
